import React, {Component} from "react";
import {Card, CardBody, Form, Input, Row} from "reactstrap";
import talentscriptLogo from "../../../assets/img/talentscript-logo.png";
import Fire from "../../../components/firebase/Fire";
import {FirebaseAuthContext} from "../../../components/firebase/FirebaseAuthProvider";
import {Link, Redirect} from "react-router-dom";
import cn from "classnames";
import LoadingSpinner from "../../../components/loadingSpinner/LoadingSpinner";
import mobileMessage from "../../../assets/img/force-desktop-message.jpg";
import "react-confirm-alert/src/react-confirm-alert.css";
import {companyInformationStatus$} from "../../company-information/company-information";
import { isMobile } from "react-device-detect";
import Swal from "sweetalert2";
import gLogo from "../../../assets/img/g-logo.png";

class Login extends Component {
	constructor(props) {

		super(props);

		this.state = {
			email: "",
			password: "",
			isLoggingIn: false,
			isLoggingError: false,
			isErrorMessageDisplayed: false,
			mobileLoginFirstTime: Login.getStatusInLocalStorage()
		};
		
		this.login = this.login.bind(this);

		this.loginGoogle = this.loginGoogle.bind(this);

		this.forgotPassword = this.forgotPassword.bind(this);

		this.handleInputChange = this.handleInputChange.bind(this);
	}

	handleInputChange(event) {
		const target = event.target;
		const value = target.type === "checkbox" ? target.checked : target.value;
		const name = target.name;

		this.setState({
			[name]: value
		});
	}

	loginGoogle(event) {
		event.preventDefault();
		if (this.state.isLoggingError) {
			this.setState({
				isErrorMessageDisplayed: true
			});
		}

		this.setState({
			isLoggingIn: true,
			isLoggingError: false
		});

		const googleAuthProvider = new Fire.auth.GoogleAuthProvider();


		Fire.auth()
			.signInWithPopup(googleAuthProvider).then(user => {
				if (user) {
					this.setState({
						isLoggingIn: false
					});
					return Fire.auth().currentUser.getIdToken(true);
				}
			}).then(token => { 

			})
			.catch(e => console.log(e.message));
	}

	static getStatusInLocalStorage() {
		return JSON.parse(localStorage.getItem("firstTimeMobileLogin") || "true");
	}

	static setStatusToLocalStorage(value = false) {
		return localStorage.setItem("firstTimeMobileLogin", value.toString());
	}

	forgotPassword() {
		Fire.auth().sendPasswordResetEmail(this.state.email)
			.then(() => {
				this.setState({isLoggingIn: false, isLoggingError: false});

				Swal.fire({
					type:"info",
					text: "An email to reset your password has been sent.",
					animation: false,
					width:350,
					customClass:{confirmButton:"sweet-alert-button"}
				});
			})
			.catch(() => this.setState({isLoggingIn: false, isLoggingError: true}));
	}

	login(event) {
		event.preventDefault();
		if (this.state.isLoggingError) {
			this.setState({
				isErrorMessageDisplayed: true
			});
		}

		this.setState({
			isLoggingIn: true,
			isLoggingError: false
		});

		const {email, password} = this.state;

		Fire.auth()
			.signInWithEmailAndPassword(email, password)
			.then(user => {
				if (user) {
					this.setState({
						isLoggingIn: false
					});
					/**heap.io **initialise identity** */
					window.heap.identify(email);
					companyInformationStatus$.next(false);
					return Fire.auth().currentUser.getIdToken(true);
				}
			})
			.then(token => console.log(token))
			.catch(() => {
				this.setState({isLoggingIn: false, isLoggingError: true});
			});
	}

	/**heap.io **track page time** */
	componentWillUnmount(){
		window.heap.track("login_page_exit");

	}

	handleImageClick() {
		Login.setStatusToLocalStorage();
		window.location.reload();
	}

	render() {

		if (isMobile && this.state.mobileLoginFirstTime) {
			return (
				<div>
					<img
						width="100%"
						height="auto"
						max-width="100%"
						src={mobileMessage}
						onClick={this.handleImageClick.bind(this)}
					></img>
				</div>
			);
		}
		const loginPage = (
			<div
				className="app bg-white"
			>
				<div className="container-fluid">
					<div className="row register-row">
						<div className="col-5 d-none register-bg d-md-flex flex-column justify-content-center">
							<img src={talentscriptLogo} className="register-logo"/>
							<div className="px-5">
								<div className="register-left-title font-weight-bold mb-3">Get ready to make better and faster hires</div>
								<div className="register-left-description">Interview, screen and schedule easily through our intuitive platform and find the most suitable candidates that will make your team grow!</div>
							</div>
						</div>
						<div className="col-12 col-md-5 offset-md-1 d-flex flex-column justify-content-center align-items-center">
							<Card className="p-3 px-lg-5 register-card fadeInAnimation border-0">
								<CardBody>
									<div className="h3 pb-4 text-center">Welcome Back</div>
									<button onClick={this.loginGoogle}
										className="btn btn-lg w-100 border rounded-sm mb-3">
										<img className="mr-3" style={{width: "20px"}} src={gLogo} alt="Sign in with Google"/>
											Sign in with Google
									</button>
									<div className="row align-items-center mb-4 pt-2">
										<div className="col">
											<div className="border-bottom border-custom" style={{height: "0"}}>&nbsp;</div>
										</div>
										<div className="col flex-grow-0 px-0" style={{color: "#b5b5b5"}}>or</div>
										<div className="col">
											<div className="border-bottom border-custom" style={{height: "0"}}>&nbsp;</div>
										</div>
									</div>
									<Form onSubmit={this.login}>
										<div className="form-group">
											<Input
												className="form-control-lg rounded-sm"
												autoComplete="email"
												type="text"
												placeholder="Username"
												name="email"
												onChange={this.handleInputChange}
											/>
										</div>
										<div className="form-group">
											<Input
												className="form-control-lg rounded-sm"
												autoComplete="password"
												type="password"
												placeholder="Password"
												name="password"
												onChange={this.handleInputChange}
											/>
										</div>
										<div>
											<button
												type="submit"
												className="btn btn-primary btn-lg btn-register w-100 rounded-sm mb-3"
											>
												Login
											</button>
											<LoadingSpinner isActive={this.state.isLoggingIn}/>
										</div>
										<div className="text-center">
											<button onClick={this.forgotPassword} type="button" className="btn btn-link btn-lg px-0">
												Forgot password?
											</button>
										</div>
										{
											this.state.isLoggingError
												? <Row
													style={{
														paddingTop: "15px",
														color: "red",
														opacity: "0"
													}}
													className={cn(
														this.state.isLoggingError
															? "fadeInAnimation"
															: this.state.isLoggingIn &&
															this.state.isErrorMessageDisplayed ? "fadeOutAnimation" : ""
													)}
												>
													<ul style={{display: "block"}}>
														<li>Invalid username or password</li>
													</ul>
												</Row>
												: null
										}

									</Form>
								</CardBody>
							</Card>
							<div className="login-register-switch d-flex align-items-center justify-content-center text-nowrap">
								New to TalentScript?
								<Link to="/register">
									<button className="btn btn-link">
										Sign Up
									</button>
								</Link>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
		return (
			<FirebaseAuthContext.Consumer>
				{({isUserSignedIn}) => {
					if (isUserSignedIn) {
						return <Redirect to="/"/>;
					}
					return loginPage;
				}}
			</FirebaseAuthContext.Consumer>
		);
	}
}

export default Login;
